
import Vue from "vue";
import {DeletedSale} from "@/models/base/deleted-sale";
import {DeletedSalesService } from "@/services/deleted-sales-service";
import { v4 } from "uuid";
import { IDataTableColumn } from "winfakt-vue-components";
import { printLocalDateTime } from "@/utils/pretty-print";
import { SaleService } from "@/services";
import { Sale } from "@/models/base";

export default Vue.extend({
	data(){
		return {
			records: -1,
			data: [] as DeletedSale[],
			limit: 500,
			orderColumn: "this.ID",
			orderAscending: false,
			fetchId: "",
			selectedItems: [] as DeletedSale[],
			openedItem: null as null | DeletedSale,
			searchInput: "",
			searchTimer: 0
		};
	},
	computed: {
		columns():IDataTableColumn[] {
			return [
				{
					name: "Verkoop ID",
					property: "SaleID",
					width: "80px"
				},
				{
					name: "Nummer",
					property: "ComputedFriendlyID",
					width: "120px"
				},
				{
					name: "Contact ID",
					property: "ContactID",
					width: "80px"
				},
				{
					name: "Datum verwijderd",
					property: "DeletedDate",
					width: "200px",
					print: printLocalDateTime
				},
				{
					name: "Verwijderd door gebruiker ID",
					property: "DeletedByUserID",
					width: "200px"
				}
			];
		}
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				if (this.selectedItems.length == 0) return;
				this.openedItem = this.selectedItems[0];
				this.selectedItems.splice(0, this.selectedItems.length);
			}
		},
		searchInput(){
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			let input = this.searchInput;
			this.searchTimer = setTimeout(()=>{
				if (this.searchInput != input) return;
				this.data.splice(0, this.data.length);
				this.records = -1;
				this.fetch();
				this.searchTimer = 0;
			}, 250);
		}
	},
	methods: {
		async fetch(){
			if (this.records != -1) {
				if (this.data.length >= this.records) return;
			}
			if (this.fetchId) return;
			let fetchId = v4();
			this.fetchId = fetchId;
			try{
				let order:"ASC" | "DESC" = this.orderAscending ? "ASC" : "DESC";
				if (this.searchInput) {
					var result = await DeletedSalesService.searchDeletedSales(this.searchInput, this.limit, this.data.length, this.orderColumn, order);
				}else{
					var result = await DeletedSalesService.getDeletedSales(this.limit, this.data.length, this.orderColumn, order);
				}
				if (fetchId != this.fetchId) return;
				if (this.data.length == 0) {
					this.records = result.records;
				}
				this.data.push(...result.data);
			}catch(err){
				console.error(err);
			}
			this.fetchId = "";
		},
		setOrderColumn(column:string, orderAscending:boolean){
			this.data = [];
			this.orderColumn = column;
			this.orderAscending = orderAscending;
			this.records = -1;
			this.fetchId = "";
			this.fetch();
		},
		close(){
			this.$emit("close");
		},
		onItemClick(item:DeletedSale){
			this.openedItem = item;
		},
		onScroll(event:Event) {
			let table = event.target as HTMLElement;
			let lastChild = table.lastChild as HTMLElement;
			if (!lastChild) {
				return;
			}

			let tableRect = table.getBoundingClientRect();
			let childRect = lastChild.getBoundingClientRect();

			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 2000)) {
				this.fetch();
			}
		},
		async restoreOpenedItem(){
			if (!this.openedItem) return;
			let item = this.openedItem;
			let sale = new Sale(JSON.parse(item.RawJson));
			let saleTypeId = await SaleService.getType(sale.TypeID);
			let contactGroupId = saleTypeId.ContactGroupID;
			if (contactGroupId == 2) {
				this.$router.push(`/purchase-documents/new?fromJson=${item.RawJson}`);
			}
			this.$router.push(`/sales/new?fromJson=${item.RawJson}`);
			this.close();
		},
		async deleteOpenedItem(){
			if (!this.openedItem) return;
			if (!confirm(`Weet je zeker dat je "${this.openedItem.ComputedFriendlyID}" definitief wilt verwijderen? Dit kan niet ongedaan worden gemaakt.`)) return;
			try {
				await DeletedSalesService.deleteDeletedSale(this.openedItem.ID);
				let index = this.data.findIndex(d => d.ID === this.openedItem!.ID);
				if (index !== -1) {
					this.data.splice(index, 1);
					this.records--;
				}
				this.openedItem = null;
			} catch (err) {
				console.error(err);
				alert("Er is een fout opgetreden bij het verwijderen.");
			}
		}
	},
	mounted(){
		this.fetch();
	}
});
